import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'My biggest problem was session planning. Football Ready gave me an entire season of structure. I spend less time planning and more time coaching.',
  author: 'Michael T.',
  role: 'Youth Football Coach'
}, {
  quote: 'The Session Vault and Player Evaluation System completely changed how I organize my team. This system is worth far more than the price.',
  author: 'James R.',
  role: 'Academy Coach'
}];
export function Testimonials() {
  return <section className="py-20 bg-navy-900 relative" data-id="element-239" data-mp="2x00552i7n4yu">
      <div className="container mx-auto px-4" data-id="element-240" data-mp="2x2w4mv9pi1pe">
        <div className="text-center mb-16" data-id="element-241" data-mp="2s2i7i89n8c65">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-4xl md:text-5xl text-white uppercase tracking-wide" data-id="element-242" data-mp="2s3t9c2jj39um">
            WHAT OTHER COACHES ARE SAYING
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-243" data-mp="78ab7gzpprhr">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-950 border border-navy-800 rounded-2xl p-8 relative" data-id="element-244" data-mp="c7dh13nio1qs" data-mpi={index}>
              <Quote className="absolute top-6 right-6 w-12 h-12 text-navy-800" data-id="element-245" data-mp="1iuii8arxizbp" />

              <div className="flex gap-1 mb-6" data-id="element-246" data-mp="1nn25jzgf58tp">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-247" data-mp="1xi8z0ytsiv89" data-mpi={i} />)}
              </div>

              <p className="text-xl text-gray-300 italic mb-8 relative z-10" data-id="element-248" data-mp="1oh2kuwem5wi6">
                "{testimonial.quote}"
              </p>

              <div data-id="element-249" data-mp="1jhg62ij50879">
                <div className="font-oswald text-xl text-white uppercase tracking-wide" data-id="element-250" data-mp="1jhyc26vlq0sd">
                  {testimonial.author}
                </div>
                <div className="text-gold-500 text-sm font-medium" data-id="element-251" data-mp="19rwkh541i08p">
                  {testimonial.role}
                </div>
                {'detail' in testimonial && testimonial.detail && <div className="text-gray-500 text-sm mt-0.5" data-id="element-252" data-mp="10s9t7c50yatd">
                    {testimonial.detail}
                  </div>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}